var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns is-centered" }, [
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "box" }, [
            _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Signar")]),
            _vm._v(" "),
            _c("h1", { staticClass: "title is-1" }, [
              _vm._v("Mi configuración"),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "media" }, [
              _c(
                "div",
                { staticClass: "media-right pt-2" },
                [
                  _c(
                    "b-field",
                    [
                      _c("b-switch", {
                        on: { input: _vm.submit },
                        model: {
                          value: _vm.editedSettings.homeSearch.showThumbnails,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedSettings.homeSearch,
                              "showThumbnails",
                              $$v
                            )
                          },
                          expression:
                            "editedSettings.homeSearch.showThumbnails",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(2),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "media" }, [
              _c(
                "div",
                { staticClass: "media-right pt-2" },
                [
                  _c(
                    "b-field",
                    [
                      _c("b-switch", {
                        on: { input: _vm.submit },
                        model: {
                          value:
                            _vm.editedSettings.recentDocuments.alwaysShowOpen,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editedSettings.recentDocuments,
                              "alwaysShowOpen",
                              $$v
                            )
                          },
                          expression:
                            "editedSettings.recentDocuments.alwaysShowOpen",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(4),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", {}, [
        _vm._v("Personalice el comportamiento de Signar en su navegador."),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "has-text-primary is-size-7" }, [
        _vm._v(
          "Nota: La siguientes opciones solo existen en este navegador. Una ventana de navegacion privada, u otro navegador, la experiencia sera por default"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { staticClass: "title is-5" }, [
      _c("i", { staticClass: "fas fa-cube" }),
      _vm._v(" Inicio / Buscador"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "media-content" }, [
      _c("h6", { staticClass: "has-text-primary" }, [
        _c("b", [_vm._v("Previsualizar resultados")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "is-size-7" }, [
        _c("p", {}, [
          _vm._v(
            "Mostrar los resultados de las busquedas con una previsualizacion (en el caso que tenga)"
          ),
        ]),
        _vm._v(" "),
        _c("p", {}, [
          _c("b", [_vm._v("Valor por defecto:")]),
          _vm._v(" Desactivado"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { staticClass: "title is-5" }, [
      _c("i", { staticClass: "fas fa-cube" }),
      _vm._v(" Inicio / Últimos documentos"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "media-content" }, [
      _c("h6", { staticClass: "has-text-primary" }, [
        _c("b", [_vm._v("Siempre desplegado")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "is-size-7" }, [
        _c("p", {}, [
          _vm._v(
            "Siempre al entrar a la pagina de inicio, mostrar desplegada la fila de documentos recientes"
          ),
        ]),
        _vm._v(" "),
        _c("p", {}, [
          _c("b", [_vm._v("Valor por defecto:")]),
          _vm._v(" Activado"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }